import React from "react"

import { StaticImage } from "gatsby-plugin-image"

import Layout from "../components/layout"
import SEO from "../components/seo"

import Row from "../components/themableUI/row"
import Col from "../components/themableUI/col"

import { ButtonLink } from "../components/button-link"

const IndexPage = () => {
  return (
    <Layout>
      <SEO title="Home" />

      <h2 style={{ display: "none" }}>Home</h2>
      <Row alignItems={"center"}>
        <Col style={{ paddingLeft: "0rem" }} size={12} sizes={{ sm: 6, md: 7 }}>
          <StaticImage
            src="../images/makeuplandingpage.jpg"
            width={800}
            quality={95}
            formats={["AUTO", "WEBP", "AVIF"]}
            alt="makeup"
          />
        </Col>
        <Col style={{ textAlign: "center" }} size={12} sizes={{ sm: 6, md: 5 }}>
          <h3>Welcome to Minimalista</h3>

          <p>
            Lorem ipsum dolor sit amet consectetur adipisicing elit. Voluptate
            eos quod facere ad consequatur? Qui quos, quidem quaerat dolorum
            ipsum molestias deleniti perferendis, dolorem, suscipit facere velit
            voluptatum odit voluptatibus.
          </p>
          <ButtonLink to="/about">Learn More</ButtonLink>
        </Col>
      </Row>
    </Layout>
  )
}

export default IndexPage
